import React from "react";

type Iconprops = React.SVGProps<SVGSVGElement>;

export const ZHIcon: React.FC<Iconprops> = (props) => (
  <svg
    width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="9.5" cy="9.5" r="9.5" fill="#DE2910" />
    <polygon fill="#FFDE00" points="5.5,5.5 6,7 7.5,7 6.3,8 6.8,9.5 5.5,8.6 4.2,9.5 4.7,8 3.5,7 5,7" />
    <polygon fill="#FFDE00" points="8,3.5 8.3,4.2 9,4.3 8.5,4.8 8.7,5.5 8,5.1 7.3,5.5 7.5,4.8 7,4.3 7.7,4.2" />
    <polygon fill="#FFDE00" points="10,5 10.3,5.7 11,5.8 10.5,6.3 10.7,7 10,6.6 9.3,7 9.5,6.3 9,5.8 9.7,5.7" />
    <polygon fill="#FFDE00" points="10.5,8 10.8,8.7 11.5,8.8 11,9.3 11.2,10 10.5,9.6 9.8,10 10,9.3 9.5,8.8 10.2,8.7" />
    <polygon fill="#FFDE00" points="8,9 8.3,9.7 9,9.8 8.5,10.3 8.7,11 8,10.6 7.3,11 7.5,10.3 7,9.8 7.7,9.7" />
  </svg>
);

export default ZHIcon;
